import { createContext, useContext, type ReactNode } from 'react'

// 현장 목록(종료일·시작일 포함) 재조회 요청 — 마커·공종 변경으로 스케줄 기간이 바뀐 뒤 정보바·D-day 를 다시 읽는다.
// 현장 목록을 소유한 화면(SchedulerPage·SchedulerSiteEmbed)이 주입한다. Provider 밖이면 아무 일도 하지 않는다.

const SiteRefreshContext = createContext<(() => void) | undefined>(undefined)

export function SiteRefreshProvider({ value, children }: { value: () => void; children: ReactNode }) {
  return <SiteRefreshContext.Provider value={value}>{children}</SiteRefreshContext.Provider>
}

export function useSiteRefresh(): () => void {
  return useContext(SiteRefreshContext) ?? (() => {})
}
